export const GET_ALL_INCOME_EXPENSE_LIST = "GET_ALL_INCOME_EXPENSE_LIST";
export const ADD_INCOME_EXPENSE_DETAILS = "ADD_INCOME_EXPENSE_DETAILS";
export const EDIT_INCOME_EXPENSE_DETAILS = "EDIT_INCOME_EXPENSE_DETAILS";
export const DELETE_INCOME_EXPENSE_DETAILS = "DELETE_INCOME_EXPENSE_DETAILS";
export const UPDATE_INCOME_EXPENSE_DETAILS = "UPDATE_INCOME_EXPENSE_DETAILS";
